// Common options: `w_WIDTH,h_HEIGHT,c_CROP,g_GRAVITY`. Order is not important.
// @see http://cloudinary.com/documentation/image_transformations
const formatTransforms = (transforms) => {
  if (!transforms || Object.keys(transforms).length === 0) {
    return ''
  }

  const formatted = Object.keys(transforms).map((key) => {
    const prefix = key === 'flags' ? key.substr(0, 2) : key[0]
    return `${prefix}_${transforms[key]}`
  })
  return formatted.join(',')
}

const formatAssetUrl = (url, transforms = {}) => {
  if (!url) return null

  const [prefix, suffix] = url.split('/upload/')
  let formattedTransforms = formatTransforms(transforms)
  if (!suffix) {
    return prefix
  }
  if (formattedTransforms !== '') {
    formattedTransforms += '/'
  }
  return `${prefix}/upload/${formattedTransforms}${suffix}`
}

export default formatAssetUrl
